import moment from 'moment';
import {
  FILTER_CUSTOM,
  FILTER_FOUR_WEEKS,
  FILTER_MONTH_TIL_TODAY,
  FILTER_ONE_WEEK,
  FILTER_ONE_YEAR,
  FILTER_QUARTER_TIL_TODAY,
  FILTER_TODAY,
  FILTER_WEEK_TIL_TODAY,
  FILTER_YEAR_TIL_TODAY,
  SELECT_FILTER,
  SET_DATES,
  SET_DIRTY,
  RESET_DIRTY,
} from './constants';
import config from '../../../config';


const selectFilter = key => ({
  type: SELECT_FILTER,
  payload: key || FILTER_CUSTOM,
});

const setDates = (firstFrom, firstTo, secondFrom, secondTo) => ({
  type: SET_DATES,
  payload: {
    first: {
      from: firstFrom,
      to: firstTo,
    },
    second: {
      from: secondFrom || null,
      to: secondTo || null,
    },
  },
});

export const setFilter = (filterKey = FILTER_ONE_WEEK) => (dispatch) => {
  const formatDate = momentDate => momentDate.format(config.dateFormatISO);

  const today = moment();

  switch (filterKey) {
    case (FILTER_TODAY): {
      dispatch(selectFilter(FILTER_TODAY));
      return dispatch(setDates(
        formatDate(today),
        formatDate(today),
        formatDate(moment(today).subtract(1, 'd')),
        formatDate(moment(today).subtract(1, 'd')),
      ));
    }

    case (FILTER_ONE_WEEK): {
      dispatch(selectFilter(FILTER_ONE_WEEK));
      return dispatch(setDates(
        formatDate(moment(today).subtract(6, 'd')),
        formatDate(today),
        formatDate(moment(today).subtract(6, 'd').subtract(1, 'w')),
        formatDate(moment(today).subtract(1, 'w')),
      ));
    }

    case (FILTER_FOUR_WEEKS): {
      dispatch(selectFilter(FILTER_FOUR_WEEKS));
      return dispatch(setDates(
        formatDate(moment(today).subtract(6, 'd').subtract(3, 'w')),
        formatDate(today),
        formatDate(moment(today).subtract(6, 'd').subtract(7, 'w')),
        formatDate(moment(today).subtract(4, 'w')),
      ));
    }

    case (FILTER_ONE_YEAR): {
      dispatch(selectFilter(FILTER_ONE_YEAR));
      return dispatch(setDates(
        formatDate(moment(today).subtract(1, 'year')),
        formatDate(today),
      ));
    }

    case (FILTER_WEEK_TIL_TODAY): {
      dispatch(selectFilter(FILTER_WEEK_TIL_TODAY));
      return dispatch(setDates(
        formatDate(moment(today).startOf('week')),
        formatDate(today),
        formatDate(moment(today).startOf('week').subtract(1, 'week')),
        formatDate(moment(today).subtract(1, 'week')),
      ));
    }

    case (FILTER_MONTH_TIL_TODAY): {
      dispatch(selectFilter(FILTER_MONTH_TIL_TODAY));
      return dispatch(setDates(
        formatDate(moment(today).startOf('month')),
        formatDate(today),
        formatDate(moment(today).startOf('month').subtract(1, 'month')),
        formatDate(moment(today).subtract(1, 'month')),
      ));
    }

    case (FILTER_QUARTER_TIL_TODAY): {
      dispatch(selectFilter(FILTER_QUARTER_TIL_TODAY));
      return dispatch(setDates(
        formatDate(moment(today).startOf('quarter')),
        formatDate(today),
        formatDate(moment(today).startOf('quarter').subtract(1, 'quarter')),
        formatDate(moment(today).subtract(1, 'quarter')),
      ));
    }

    case (FILTER_YEAR_TIL_TODAY): {
      dispatch(selectFilter(FILTER_YEAR_TIL_TODAY));
      return dispatch(setDates(
        formatDate(moment(today).startOf('year')),
        formatDate(today),
        formatDate(moment(today).startOf('year').subtract(1, 'year')),
        formatDate(moment(today).subtract(1, 'year')),
      ));
    }

    default:
      return null;
  }
};

export const setCustomRange = (firstFrom, firstTo, secondFrom, secondTo) => (dispatch) => {
  dispatch(selectFilter(FILTER_CUSTOM));
  return dispatch(setDates(firstFrom, firstTo, secondFrom, secondTo));
};

export const setDirty = () => dispatch => dispatch({
  type: SET_DIRTY,
});

export const resetDirty = () => dispatch => dispatch({
  type: RESET_DIRTY,
});
